import React, {useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, Row, Col, Statistic, Divider, Button, Alert } from 'antd';
import { TeamOutlined, CalendarOutlined, TrophyOutlined, MergeCellsOutlined, LinkOutlined, EnvironmentOutlined, CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { motion } from 'motion/react';
import { api } from '../../AppConfig';
import AddTournamentParticipant from '../../components/AddTournamentParticipant';
import UpdateDecklists from '../../components/UpdateDecklists';
import { dateFormat } from '../../utils';
import RankingTable from '../../components/RankingTable';
import ParticipantTable from '../../components/ParticipantTable';
import * as Setting from '../../utils/AuthUtils';
import UpdateTournament from '../../components/UpdateTournament';
import AssignBye from '../../components/AssignBye';
import { filterByes } from '../../utils/DataUtils';
import AddTournamentLocation from '../../components/AddTournamentLocation';
import LocationMap from '../../components/LocationMap';
import { useTranslation } from 'react-i18next';
import DeleteTournamentLocation from '../../components/DeleteTournamentLocation';

function Tournament(props) {
  const [editable, setEditable] = useState(false)
  const { t } = useTranslation();

  async function addPlayer(stageId, participant) {
    // console.warn('arrivato alla chiamata ajax! ', participant)
    participant.tournamentId = stageId;
    // setLoading(true)
    props.addPlayer.mutate(participant);
  }

  function toggleEditable(e) {
    e.preventDefault();
    if (editable) {
      setEditable(false)
    } else {
      setEditable(true)
    }
  }

  function toggleDownloadButton(tournament) {
    fetch(api.tournaments().decklists(tournament.id).href, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + Setting.getToken(),
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then(res => {
        if (res.status !== 200) {
          throw new Error("Bad server response!");
        }
        return res.blob();
      })
      .then((data) => {
        console.warn('fetched csv:', data);
        var url = window.URL.createObjectURL(data),
        anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = "decklist_tournament_"+tournament.id+".csv";
        anchor.click();

        // (C2) CLEAN UP
        window.URL.revokeObjectURL(url);
        document.removeChild(anchor);
      })
      .catch(err => console.error(err));
  }

  function setSplitLabel(tournament) {
    if (tournament && tournament.multiplier) {
      switch (tournament.multiplier.id) {
        case 6:
          return "Top8";
        case 7:
          return "Top4";
        case 8:
          return "Top2";
        default:
          return "None";
      }
    }
    return '';
  }

  function showByes(byes) {
    const showRes = [];
    byes.forEach(bye => {
      showRes.push(<Col span={4}><Card>{bye.playerInfo.lastName} {bye.playerInfo.firstName}</Card></Col>)
    });
    return showRes;
  }

  function showLocationName(tournament) {
    if (tournament && tournament.location && tournament.location.name) {
      return tournament.location.name;
    }
    return tournament.place;
  }

  function showLeagueName(tournament) {
    if (tournament && tournament.leagueInfos && tournament.leagueInfos.leagueName) {
      return tournament.leagueInfos.leagueName;
    }
    return '';
  }

  function showParticipantsLabel(tournament) {
    console.warn('checking if is a pte or a single player event', tournament);
    if (tournament && tournament.type && (tournament.type.id === 4 || tournament.type.id === 5)) {
      return 'Teams';
    }
    return t('tournaments.participants');
  }

  function showDecklistRequiredStatus(tournament) {
    if (tournament && tournament.canUploadDecklist) {
        return (<CheckCircleTwoTone twoToneColor="#52c41a" />)
    }
    return (<CloseCircleTwoTone twoToneColor="#eb2f96" />)
  }

  function showUploadLink(tournament) {
    if (tournament && tournament.canUploadDecklist) {
      const url = `https://www.decklists.legapauperitalia.com/?event=${tournament.id}`
      return (<a href={url} target="_blank" rel="noreferrer"><Button type="primary">{t('decks.uploadPage')}</Button></a>)
    }
    return (<Button type="primary" disabled>{t('decks.uploadPage')}</Button>)
  }

  function showDownloadLink(tournament) {
    if (tournament && tournament.canUploadDecklist) {
      // const url = `https://www.elmariachistudios.it/ws/tournaments/${tournament.id}/downloadDecklists`
      return (<Button type="primary" onClick={() => toggleDownloadButton(tournament)}>{t('decks.download')}</Button>)
    }
    return (<Button type="primary" disabled>{t('decks.download')}</Button>)
  }

  const participants = (props.participants.data && props.participants.data.payLoad !== null ? props.participants.data.payLoad : []);
  const tournament = (props.tournament.data && props.tournament.data.payLoad !== null ? props.tournament.data.payLoad : {});
  const dividerTitle = (props.tournament.data && props.tournament.data.payLoad !== null && props.tournament.data.payLoad.turns > 10 ? 'Top16' : 'Top8');
  const byes = (props.byes.data && props.byes.data.payLoad !== null ? filterByes(props.byes.data.payLoad, props.id) : [])
  
  // console.warn('byes del torneo assegnati:', byes)
  if (tournament.isDone === true || editable) {
    return (
      <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="content-body">
      <Card loading={ props.tournament.pending || props.participants.pending } title={tournament.name} style={{ marginTop: '24px' }}>
        <Row gutter={16} justify="center">
          <Col span={4}>
            <Statistic title={t('tournaments.startDate')} value={dateFormat(tournament.date)} prefix={<CalendarOutlined />} />
          </Col>
          <Col span={4}>
            <Statistic title={t('tournaments.type')} value={(tournament && tournament.type && tournament.type.desc) || ''} prefix={<TrophyOutlined />}/> 
          </Col>
          { tournament && tournament.type && tournament.type.id > 3 && tournament.type.id !== 14 &&
            <Col span={4}>
              <Statistic title={t('tournaments.turns')} value={tournament.turns} prefix={<MergeCellsOutlined />} />
            </Col>
          }
          <Col span={4}>
            <Statistic title={showParticipantsLabel(tournament)} value={tournament.playerAttendancy} prefix={<TeamOutlined />}/>
          </Col>
          <Col span={4}>
            <Statistic title="Split" value={setSplitLabel(tournament)} prefix={<TeamOutlined />}/>
          </Col>
        </Row >
        { Setting.isLoggedIn() && tournament.canEdit === true && 
          <Row justify="center">
            <Col span={6}><AddTournamentParticipant onAddPlayer={addPlayer} stageId={tournament.id}/></Col>
            <Col span={6}><UpdateTournament tournament={tournament} multipliers={props.multipliers} rights={props.hasRights} ranking={participants}/></Col>
          </Row>
        }
        { tournament.type && tournament.type.id === 12  &&
          <Row gutter={16} justify="center" style={{ marginTop: '16px' }} >
            <Col xs={24} sm={24} md={24} lg={10} xl={10} style={{fontSize:"20px"}}>
              <Alert type="error" title="This event is not part of the LPI circuit, so it will not distribute LPI points" showIcon/>
            </Col>
          </Row>
        }
        <Divider>{t('tournaments.info')}</Divider>
        <Row gutter={16} justify="center">
          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            <Card title={t('tournaments.organizer')} className="league-desc">
              <span><TeamOutlined /> {`Lega Pauper ${showLeagueName(tournament)}`}</span>
            </Card>
          </Col>
          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            <Card title={t('tournaments.place')} className="league-desc">
              <span><EnvironmentOutlined /> {showLocationName(tournament)}</span>
            </Card>
          </Col>
          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            <Card title={t('tournaments.externalLink')} className="league-desc" >
              <span><LinkOutlined /> <a href={tournament.externalLink} target="_blank" rel="noreferrer">{tournament.externalLink}</a></span>
            </Card>
          </Col>
        </Row>
        { tournament && (tournament.location && tournament.location.id !== 0) &&
          <Row>
            <Col span={24}>
              <LocationMap location={tournament.location} />
            </Col>
          </Row>
        } 
        { Setting.isLoggedIn() && tournament.canEdit === true && tournament && (tournament.location && tournament.location.id === 0) &&
          <Row justify="center">
            <Col span={6}><AddTournamentLocation tournamentId={tournament.id}/></Col>
          </Row>
        }
        {
          tournament && tournament.hasByes &&
          <>
          <Divider>Byes</Divider>
            <p><b>{byes.length || 'No'}</b> byes assigned for this tournament</p>
            <Row justify="space-evenly">
              {showByes(byes)}
            </Row>
            { Setting.isLoggedIn() && tournament.canEdit === true &&
              <Row justify="center">
                <Col span={6}><AssignBye tournament={tournament} participant={participants} lpiSeasons={props.lpiSeasons}/></Col>
              </Row>
            }
          </>
        }
        <Divider>Decklists</Divider>
        <Row gutter={16} justify="center">
          <Col span={12} style={{fontSize:"20px"}}>
            <a href={tournament.decklist || '#'} target="_blank" rel="noreferrer"><p><LinkOutlined /> {tournament.decklist || ' Not available'}</p></a>
          </Col>
        </Row>
        <Row gutter={16} justify="center">
          {
              Setting.isLoggedIn() && tournament.canEdit === true && tournament.isDone === true &&
              
                <Col span={12} style={{fontSize:"20px"}}>
                  <UpdateDecklists tournament={tournament} />
                </Col>
          }
        </Row>
        <Divider>{dividerTitle}</Divider>
        <Row>
          <Col span={24}>
            {
              Setting.isLoggedIn() && tournament.canEdit === true && tournament.isDone === true && editable === false &&
              <Row justify="center">
                <Col span={4}><Button style={{ marginBottom: 16 }} onClick={toggleEditable} type="primary">EDIT RANKING</Button></Col>
                <Col span={4}><Link to={`/tournaments/${tournament.id}/import-results`}><Button style={{ marginBottom: 16 }} type="primary">IMPORT RESULTS</Button></Link></Col>
              </Row>
            }
            <RankingTable admin={props.hasRights.isAdmin} rights={props.hasRights} editing={editable} toggleEditing={toggleEditable} isTournament={true} dataSource={participants} {...props} />
          </Col>
        </Row>
      </Card>
      </motion.div>
    );
  }
  return (
      <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="content-body">
      <Card loading={props.tournament.pending || props.participants.pending} title={tournament.name} style={{ marginTop: '24px' }}>
        <Row gutter={16} justify="center" style={{ marginBottom: '16px' }}>
          <Col span={4}>
            <Statistic title={t('tournaments.startDate')} value={dateFormat(tournament.date)} prefix={<CalendarOutlined />} />
          </Col>
          <Col span={4}>
            <Statistic title={t('tournaments.type')} value={(tournament && tournament.type && tournament.type.desc) || ''} prefix={<TrophyOutlined />}/> 
          </Col>
          { tournament && tournament.type && tournament.type.id > 3 &&
            <Col span={4}>
              <Statistic title={t('tournaments.turns')} value={tournament.turns} prefix={<MergeCellsOutlined />} />
            </Col>
          }
          <Col span={4}>
            <Statistic title={t('tournaments.cap')} value={tournament.playerCap} prefix={<TeamOutlined />}/>
          </Col>
          <Col span={4}>
            <Statistic title="Split" value={setSplitLabel(tournament)} />
          </Col>
        </Row >
        { Setting.isLoggedIn() && tournament.canEdit && !tournament.isDone && 
          <Row justify="center" style={{ marginBottom: '16px' }}>
            <Col span={8}><AddTournamentParticipant onAddPlayer={addPlayer} stageId={tournament.id}/></Col>
            <Col span={8}><UpdateTournament tournament={tournament} multipliers={props.multipliers} rights={props.hasRights} ranking={participants}/></Col>
          </Row>
        }
        { tournament.type && tournament.type.id === 12  &&
          <Row gutter={16} justify="center" >
            <Col xs={24} sm={24} md={24} lg={10} xl={10} style={{fontSize:"20px"}}>
              <Alert type="error" title="This event is not under the LPI circuit, so it will not distribute LPI points" showIcon/>
            </Col>
          </Row>
        }
        {
          Setting.isLoggedIn() && tournament.canEdit === true && tournament.isDone === false &&
          <Row gutter={16} justify="center" >
            <Col xs={24} sm={24} md={24} lg={10} xl={10} style={{fontSize:"20px"}}>
              <Alert type="error" title="The event is still open, click on MANAGE TOURNAMENT button once ready to close it" showIcon/>
            </Col>
          </Row>
        }
        <Divider>{t('tournaments.info')}</Divider>
        <Row gutter={16} justify="center" style={{ marginBottom: '16px' }}>
          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            <Card title={t('tournaments.organizer')} className="league-desc">
              <span><TeamOutlined /> {`Lega Pauper ${showLeagueName(tournament)}`}</span>
            </Card>
          </Col>
          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            <Card title={t('tournaments.place')} className="league-desc">
              <span><EnvironmentOutlined /> {showLocationName(tournament)}</span>
            </Card>
          </Col>
          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            <Card title={t('tournaments.externalLink')} className="league-desc">
              <span><LinkOutlined /> <a href={tournament.externalLink} target="_blank" rel="noreferrer">{tournament.externalLink}</a></span>
            </Card>
          </Col>
        </Row>
        <Row>
          { tournament && (tournament.location && tournament.location.id !== 0) &&
            <Col span={24}>
              <Row justify="center" style={{ marginBottom: '10px' }}>
                <Col span={24} style={{fontSize:"20px"}}>
                  <LocationMap location={tournament.location} />
                </Col>
              </Row>
              <Row justify="center">
                <DeleteTournamentLocation location={tournament.location} tournamentId={tournament.id}/>
              </Row>
            </Col>
          }
        </Row>
        { Setting.isLoggedIn() && tournament.canEdit === true && tournament && (tournament.location && tournament.location.id === 0) && 
          <Row justify="center">
            <Col span={6}><AddTournamentLocation tournamentId={tournament.id}/></Col>
          </Row>
        }
        <Divider>Decklists</Divider>
        <Row gutter={16} justify="center">
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <Card title={t('decks.required')} className="league-desc">
              {showDecklistRequiredStatus(tournament)}
            </Card>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <Card title={t('decks.uploadLink')} className="league-desc">
              {showUploadLink(tournament)}
            </Card>
          </Col>
          { 
            Setting.isLoggedIn() && tournament.canEdit === true &&
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Card title={t('decks.toShowJudge')} className="league-desc">
               {showDownloadLink(tournament)}
              </Card>
            </Col>
          }
        </Row>
        <Divider>{t('tournaments.ranking')}</Divider>
        {
          Setting.isLoggedIn() && tournament.canEdit === true && tournament.isDone !== true && editable === false &&
          <Row justify="center">
            <Col span={4}><Button style={{ marginBottom: 16 }} onClick={toggleEditable} type="primary">UPDATE RANKING</Button></Col>
            <Col span={4}><Link to={`/tournaments/${tournament.id}/import-results`}><Button style={{ marginBottom: 16 }} type="primary">IMPORT RESULTS</Button></Link></Col>
          </Row>
        }
        {
          Setting.isLoggedIn() && tournament.canEdit === true && tournament.isDone === true && editable === false &&
          <Row justify="center">
            <Col span={4}><Button style={{ marginBottom: 16 }} onClick={toggleEditable} type="primary">EDIT RANKING</Button></Col>
            <Col span={4}><Link to={`/tournaments/${tournament.id}/import-results`}><Button style={{ marginBottom: 16 }} type="primary">IMPORT RESULTS</Button></Link></Col>
          </Row>
        }
        <Row>
          <Col span={24} style={{padding: '10px'}}>
            <ParticipantTable admin={props.hasRights.isAdmin} rights={props.hasRights} editing={editable} toggleEditing={toggleEditable} dataSource={participants} isTournament={true} {...props} />
          </Col>
        </Row>
      </Card>
      </motion.div>
  );
}

export default Tournament;